import React, { cache } from 'react';
import { useRouter } from 'next/router';
import { useSession, signIn, signOut, getSession } from "next-auth/react";
import Image from "next/image";
import Head from 'next/head'
import FCTLogoDark from "../../icons/fc-logo.png";
import oneLogoWhite from "../../icons/one_logo_white_blue.png"
import EDXLogoLight from "../../public/images/edx-logo-light.png"
import EDXLogoDark from "../../public/images/edx-logo-dark.png"
import centreImage1 from "../../icons/CenterContent1.png";
import centreImage2 from "../../icons/CenterContent2.png";
import dark_center_img2 from "../../icons/dark_center_img3.png";
import dark_center_img1 from "../../icons/dark_center_img4.png";
import azureicon from "../../icons/azure.svg";
import microsofticon from "../../icons/microsoft-icon.png"
import azuredarkicon from "../../icons/azure-dark.svg";
import oktaicon from "../../icons/okta.svg";
import oktadarkicon from "../../icons/okta-dark.svg";
import styles from "../../styles/Home.module.css";
import fctlogo from "../../icons/fctlogo.svg";
import FCTLogoLight from "../../icons/FCTLogoLight.gif";
import Modal from 'react-modal';
import ApiUrl from '../../url.json';
import { usePasswordToggle } from '../../hooks/usePasswordToggle';
import cancelRequests from '../../utils/cancelRequests';
Modal.setAppElement('#__next');

import linkedInLogo from "../../icons/linkedin.png";
import { useState, useEffect } from "react";

import Avatar from "react-avatar";
import { FaUser } from "react-icons/fa";
import { useTheme } from "next-themes"
import { global } from 'styled-jsx/css';
import { trusted } from 'mongoose';
import { success } from 'toastr';
import constants from '../../config/constants';
export default function SignOut() {
  const { createCancelableFetchOptions } = cancelRequests();
  const router = useRouter();
  const { theme, setTheme } = useTheme();
  const [images, setImages] = useState([]);
  const [FCTLogo, setFCTLogo] = useState(FCTLogoDark);
  const [oneLogo, setOneLogo] = useState(oneLogoWhite)
  const [footerlogo, setFooterLogo] = useState(FCTLogoLight);
  const [action, setAction] = useState('Sign In')
  const [topSuggestion, setTopSuggestion] = useState({ text: "Don't have an account?", action: "Register" })
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')
  const [validEmail, setValidEmail] = useState(true)
  const [loading, setLoading] = useState(false)
  const [azureLoading, setAzureLoading] = useState(false)
  const [passVisible, passEye, togglePassVisiblility] = usePasswordToggle()
  var preverifyobj = {};
  const [isStaySignedInModalOpen, setIsSignedInModalOpen] = useState(false)
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  useEffect(() => {
    setValidEmail(true)
    setLoading(false)
    setAzureLoading(false)
    setIsSignedInModalOpen(false)
    setAction('Sign In')
    setSuccess('')
    //setAction('Reset Credentials')
  }, [])

  useEffect(() => {
    setSuccess('')
    setError('')
  }, [action])


  useEffect(() => {
    const getSystemTheme = async () => {

      const darkThemeImages = [dark_center_img1, dark_center_img2];
      const defaultImages = [centreImage1, centreImage2];
      const currentImages = theme === "dark" ? darkThemeImages : defaultImages;
      setImages(currentImages);
      setOneLogo(oneLogoWhite)
      setFCTLogo(theme === "dark" ? fctlogo : FCTLogoLight);
      // setFCTLogo(theme === "dark" ? fctlogo : FCTLogoDark);
      setFooterLogo(
        theme === "dark"
          ? FCTLogoLight
          : theme === "classic"
            ? FCTLogoLight
            : FCTLogoDark
      );
    };
    getSystemTheme();
  }, [setTheme, theme]);

  async function handleOtpVerification(event) {
    event.preventDefault()
    //setLoading(true)
    const formData = new FormData(event.target);
    const otp = formData.get("otp");


    //setLoading('Loading..')
    setSuccess("OTP Verified")
    const session = await getSession();
    localStorage.setItem('jwt', session.user.token);
    //setLoading(false)
  }

  function handleSubmit(event) {

    event.preventDefault()
    setError('')
    setSuccess('')
    const elements = document.querySelectorAll('[id^="required-error-"]');
    elements.forEach(element => {
      element.textContent = ''
    });
    let isFormValid = false;
    if (!validEmail) {
      return false
    }
    const credentialData = new FormData(event.target)
    for (let key of credentialData.keys()) {
      if (credentialData.get(key).trim() === '') {
        const errorId = 'required-error-' + key
        const errorSpan = document.getElementById(errorId);
        errorSpan.textContent = 'required field';
        return false
      }
      else {
        isFormValid = true
      }
    }
    if (isFormValid) {
      if (action == 'Sign In') {
        handleLogin(event)
      }
      else if (action == 'Register') {
        handleRegister(event)
      }
      else if (action == 'Reset Password') {
        handleForgotPass(event)
      }
      else if (action == 'OTP Verification') {
        handleOtpVerification(event)
      }
      else {
        setError('Action not Found')
      }
    }
  }

  const setStateFromChild = (message) => {
    setAction(message);
  }

  const handleLogin = async (event) => {
    //event.preventDefault();
    event.preventDefault();
    setLoading(true)
    const formData = new FormData(event.target);
    const username = formData.get("username");
    const password = formData.get("password");
    setUserName(username);
    setPassword(password);
    const csrfToken = formData.get("csrfToken")
    //setLoading('Loading..')
    setError(null)
    setSuccess(null)
    try {
      var apiurl = ApiUrl.newUrl + "/api/presignin";
      const options = createCancelableFetchOptions({
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          username: username,
          password: password,
          isportal: true,
          isSecurityCheck: false,
          isOTPSecurityCheck: true,
        }),
      })
      const res = await fetch(apiurl, options);

      const resp = await res.json();
      // console.log(resp);
      if (resp && resp.secToken) {

        if (resp.userLoginType == 0 || (resp.roles[0] != "External User" && resp.userLoginType == 1)) {
          if (true) {

          }
          if (resp.isNewUser) {
            preverifyobj = resp;
            preverifyobj.username = username;
            preverifyobj.password = password;

            localStorage.setItem('preverifyobj', JSON.stringify(preverifyobj));
            setAction('Reset Credentials');
          }
          else {
            const signInResponse = await signIn("credentials",
              {
                username: username,
                password: password,
                redirect: false
              }
            )
            if (signInResponse.error) {
              setLoading(false)
              setError("Sign in failed. Check the details you provided are correct.");
            }
            else {
              if (true) {
                //   setIsSignedInModalOpen(true)
              }

              const updatedSession = await getSession(); // Wait for session to update
              if (updatedSession) {
                setLoading(false)
                // console.log('Redirecting to home page...');
              }
            }
          }
        }
        else {
          preverifyobj = resp;
          preverifyobj.username = username;
          preverifyobj.password = password;

          localStorage.setItem('preverifyobj', JSON.stringify(preverifyobj));
          setAction('OTP Verification')
          setLoading(false)
        }



      }
      else if (resp && resp.msg === "Your account is not active please contact Admin") {
        setError("Your account is not active please contact Admin")
        setLoading(false)
      }
      else {
        setError("Enter a valid UserID/Password.");
        setLoading(false)
      }


    } catch (error) {
      // console.log(error)
      setError("An error occurred. Please try again later.");
      setAction('OTP Verification')
      setLoading(false)
      alert('Unable to send the request. Try again later.')
    }

  };

  const handleRegister = async (event) => {
    //register
    event.preventDefault();
    setLoading(true)
    const formData = new FormData(event.target);
    const firstname = formData.get("firstname");
    const lastname = formData.get("lastname");
    const email = formData.get("email");
    const company = formData.get("company")
    var apiurl = ApiUrl.newUrl + "/api/userregistration";
    const options = createCancelableFetchOptions({
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        firstname: firstname,
        lastname: lastname,
        email: email,
        company: company
      }),
    })
    try {
      const res = await fetch(apiurl, options);

      const resp = await res.json();
      // console.log(resp);
      if (resp && resp.success) {
        const successMsg = "Registration Successful! You will receive an email notification once the administrator creates your account in the application!"
        setSuccess(successMsg)
        setLoading(false)
      }
      else {
        setLoading(false);
        setError("Unable to send the request. Try again later.")
      }
    }
    catch (error) {
      console.error("Error during registration:", error);
      setLoading(false);
      setError("Unable to send the request. Try again later.");
      alert('Unable to send the request. Try again later.')
    }


  }

  const handleForgotPass = async (event) => {
    //forgot pass
    setLoading(true)
    const formData = new FormData(event.target);
    const email = formData.get("email");
    var apiurl = ApiUrl.newUrl + "/api/forgotPassword";
    const options = createCancelableFetchOptions({
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: email
      }),
    })
    try {
      const res = await fetch(apiurl, options);

      const resp = await res.json();
      // console.log(resp);
      if (resp && resp.success) {
        setSuccess("If the email ID is valid, you will receive a temporary password via email.")
        setLoading(false)
      }
      else if (resp && resp.msg == 'Your account is not active please contact Admin') {
        setLoading(false);
        setError("Your account is not active please contact Admin")
      }
      else if (resp && resp.msg == 'Authentication failed. Invalid username or password.') {
        setLoading(false);
        setError("Enter a valid Email ID")
      }
      else if (resp && resp.msg == 'Company is inactive. Please contact Admin') {
        setLoading(false);
        setError("Company is inactive. Please contact Admin")
      }
      else {
        setLoading(false);
        setError("Unable to send the request. Try again later.")
      }
    } catch (error) {
      console.error("Error during forgot password request:", error);
      setLoading(false);
      setError("Unable to send the request. Try again later.");
      alert('Unable to send the request. Try again later.')
    }

  }
  function validateCapsLock(event) {
    if (event.getModifierState) {
      const isCapsLockOn = event.getModifierState('CapsLock');
      const errorSpan = document.getElementById('capsLockCheck');
      if (isCapsLockOn) {
        errorSpan.textContent = 'CapsLock is on';
      }
      else {
        errorSpan.textContent = '';
      }
    }
  }
  function validateEmail(reqErrID) {
    const reqSpanElement = document.getElementById(reqErrID);
    reqSpanElement.textContent = '';

    const emailInput = document.getElementById('email').value;
    const errorSpan = document.getElementById('email-error');
    const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!emailPattern.test(emailInput)) {
      errorSpan.textContent = 'Please enter a valid email address.';
      setValidEmail(false)
      return false; // Prevent form submission
    } else {
      errorSpan.textContent = '';
      setValidEmail(true)
      return true; // Allow form submission
    }
  }


  let signInForm = <div className={styles.formContent}>
    <form id='login' method="post" onSubmit={handleSubmit}>
      <label htmlFor="username" id="username">Email ID</label><span className='requiredStar'>*</span>
      <br></br>
      <input id='email' onKeyDown={(e) => validateCapsLock(e)} onKeyUp={() => validateEmail('required-error-username')} name="username" type="text" placeholder='Email ID' />
      <span className={styles.validationError} id='email-error'></span>
      <span className={styles.validationError} id='required-error-username'></span>
      <br></br>
      <label htmlFor="password" id="password">Password</label><span className='requiredStar'>*</span>
      <br></br>
      <div className='inputBox'>
        <input onKeyDown={(e) => validateCapsLock(e)} name="password" type={passVisible ? 'text' : 'password'} placeholder='Password' autoComplete='new-password' />
        <span className={styles.passEyeIcon} onClick={togglePassVisiblility}>{passEye}</span>
      </div>
      <span className={styles.validationError} id='required-error-password'></span>
    </form>
    <span id='capsLockCheck' className={styles.capsLockError}></span>
    <button form='login' disabled={loading} className={styles.loginButton}>Admin {action}</button>
    {/* <button form='login' disabled={loading} className={styles.loginButton} style={{fontSize:"30px"}}>{action}</button> */}
  </div>

  let registerForm = <div className={styles.formContent}>
    <form id='login' method="post" onSubmit={handleSubmit}>
      <label htmlFor="firstname" id="firstname">First Name</label><span className='requiredStar'>*</span>
      <br></br>
      <input onKeyDown={(e) => validateCapsLock(e)} name="firstname" id="firstname" type="text" placeholder='First Name' />
      <span className={styles.validationError} id='required-error-firstname'></span>
      <br></br>
      <label htmlFor="lastname" id="lastname">Last Name</label><span className='requiredStar'>*</span>
      <br></br>
      <input onKeyDown={(e) => validateCapsLock(e)} name="lastname" id="lastname" type="text" placeholder='Last Name' />
      <span className={styles.validationError} id='required-error-lastname'></span>
      <br></br>
      <label htmlFor="email" id="userEmail">Email</label><span className='requiredStar'>*</span>
      <br></br>
      <input onKeyDown={(e) => validateCapsLock(e)} onKeyUp={() => validateEmail('required-error-email')} name="email" id="email" type="text" placeholder='Email' />
      <span className={styles.validationError} id='email-error'></span>
      <span className={styles.validationError} id='required-error-email'></span>
      <br></br>
      <label htmlFor="company" id="company">Company</label><span className='requiredStar'>*</span>
      <br></br>
      <input onKeyDown={(e) => validateCapsLock(e)} name="company" id="company" type="text" placeholder='Company' />
      <span className={styles.validationError} id='required-error-company'></span>
    </form>
    <span id='capsLockCheck' className={styles.capsLockError}></span>
    <button form='login' disabled={loading} className={styles.loginButton}>{action}</button>
  </div>

  let resetPassForm = <div className={styles.formContent}>
    <form id='login' method="post" onSubmit={handleSubmit}>
      <label htmlFor="email" id="userEmail">Email</label><span className='requiredStar'>*</span>
      <br></br>
      <input onKeyDown={(e) => validateCapsLock(e)} onKeyUp={() => validateEmail('required-error-email')} name="email" id="email" type="text" placeholder='Email' />
      <span className={styles.validationError} id='email-error'></span>
      <span className={styles.validationError} id='required-error-email'></span>
      {/* <label htmlFor="securityquestion">Choose a security question</label>
      <br></br>
      <select name="securityquestion" id="securityquestion">
        <option value="birthCity">What city were you born in?</option>
        <option value="oldestCusinMiddleName">What was the middle name of your oldest cousin?</option>
        <option value="favoriateBook">Your favoriate book</option>
        <option value="favoriateGame">your favoriate game</option>
      </select>
      <br></br>
      <label className={styles.hidden} htmlFor="securityanswer">Answer</label>
      <input onKeyDown={(e) => validateCapsLock(e)} name="securityanswer" id="securityanswer" type="text" placeholder='Answer' />
      <span className={styles.validationError} id='required-error-securityanswer'></span> */}
    </form>
    <span id='capsLockCheck' className={styles.capsLockError}></span>
    <button form='login' disabled={loading} className={styles.loginButton}>{action}</button>
  </div>

  return (
    <>
      <Head>
        <title>Work With Friends</title>
      </Head>
      <div className={styles.loginPage}>
        <div className={styles.mainDiv}>


          <div className={styles.infoDiv}>
            <img
              className={styles.image}
              src="images/login_page_image.png"
              alt="Logo"
            />
            <div className={styles.heading}>
              <h1 className={styles.headingTitle}>Refer and Earn</h1>
              <h3 className={styles.subHeading}>Help talent get Hired</h3>

            </div >
            {/* <div className={styles.about}>
              <ul>
                <li>Secure data sharing for Design & Manufacturing organizations.</li>
                <li>Seamless integration with PLM & CAD systems.</li>
                <li>Approval workflows and robust audit logging for tracking.</li>
                <li>Boosts collaboration and productivity, reducing time-to-market.</li>
                <li>Advanced security measures to prevent IP leakage.</li>
              </ul>
            </div> */}
            <div className={styles.poweredByDiv}>
              Powered by <Image src={FCTLogoLight} height={30} />
            </div>
          </div>
        </div>
        <div className={styles.loginDiv}>
          <div className={styles.infoHeader}>
            <Image src={FCTLogoDark} height={40} />
            {/* <Image src={oneLogo} height={45} /> */}
          </div>
          <div className={styles.loginFormDiv}>
            <div className={styles.heading}>
              {action == 'Sign In' &&
                <p>
                  <span>Login to</span><br />
                  <span>Work With Friends</span>
                </p>
              }
              {action != 'Sign In' &&
                <p>{action} </p>
              }
            </div>
            <div className={styles.topSuggestion}>
              {action == 'Register' && <span>{topSuggestion.text}&nbsp;{<span onClick={() => { setError(''), setAction('Sign In'), setTopSuggestion({ text: "Don't have an account?", action: "Register" }) }} className={styles.actionText}>{topSuggestion.action}</span>}</span>}
              {/* {action == 'Sign In' && <span>{topSuggestion.text}&nbsp;{<span onClick={() => { setError(''), setAction('Register'), setTopSuggestion({ text: "Go back to", action: "Sign In" }) }} className={styles.actionText}>{topSuggestion.action}</span>}</span>} */}
              {action == 'Reset Password' && <span>Go back to&nbsp;{<span onClick={() => { setError(''), setAction('Sign In'), setTopSuggestion({ text: "Don't have an account?", action: "Register" }) }} className={styles.actionText}>Sign In</span>}</span>}
              {(action == 'OTP Verification' || action == 'Reset Credentials') && <span>{"Go back to"}&nbsp;{<span onClick={() => { setError(''), setAction('Sign In'), setTopSuggestion({ text: "Don't have an account?", action: "Register" }) }} className={styles.actionText}>{"Sign In"}</span>}</span>}

            </div>
            <div className={styles.mainContent}>
              {action == 'Sign In' && signInForm}
              {action == 'Register' && registerForm}
              {action == 'Reset Password' && resetPassForm}
              {action == 'OTP Verification' && <OtpVarification updateParentState={setStateFromChild} userName={userName} password={password} />}
              {action == 'Reset Credentials' && <ResetCredModal />}
            </div>
          </div>
          {error && <div className={styles.error}>
            {error}
          </div>}
          {success && <div className={styles.success}>
            {success}
          </div>}
          <div className={styles.bottomSuggestion}>
            {/*(action != 'Reset Password' && action != 'Register' && action != 'Reset Credentials') && <span>Forgot&nbsp;{<span onClick={() => { setError(''), setSuccess(''), setAction('Reset Password'), setTopSuggestion({ text: "Go back  to", action: "Sign In" }) }} className={styles.actionText}>password?</span>}</span>*/}
            {/* {action == 'Reset Password' && <span>Don&apos;t have an account?&nbsp;{<span onClick={() => { setError(''), setSuccess(''), setAction('Register'), setTopSuggestion({ text: "Go back to", action: "Sign In" }) }} className={styles.actionText}>Register</span>}</span>} */}
          </div>
          <hr className={styles.hr}></hr>
          <div className={styles.azureLoginDiv}>
            {/* <div className={styles.heading}> */}
            <button disabled={azureLoading} onClick={() => { signIn("azure-ad"), setAzureLoading(true) }} className={styles.azureLoginButton}> <Image style={{ paddingBottom: '2px', paddingRight: '0px' }} src={microsofticon} height={30} width={30} /> FourColors - Employee Sign In</button>
            {/* <button disabled={azureLoading} onClick={() => { signIn("azure-ad"), setAzureLoading(true) }} className={styles.azureLoginButton} style={{fontSize:"30px"}}>ONE Employee - <Image style={{ paddingBottom: '2px', paddingRight: '0px' }} src={microsofticon} height={30} width={30} />Sign in with Azure AD</button> */}
          </div>
          {/* <div className={styles.supportContentDiv}>
            For any login or support inquiries, please contact: <a href={"mailto:" + constants.globalSupportEmail}>Support Email</a>.
          </div> */}
        </div>
        {/* <StaySignedInModal isOpen={isStaySignedInModalOpen} onRequestClose={() => setIsSignedInModalOpen(false)} /> */}
      </div>
    </>
  )
}
export function StaySignedInModal({ isOpen, onRequestClose, isNewUser, onResponse }) {

  //const [modalOpen, setModalOpen] = useState(false)
  const [askStaySignedIn, setAskSignedIn] = useState(true)

  useEffect(() => {
    setAskSignedIn(true)
  }, [])

  function onSubmit(staySignedIn) {
    global.__staySignedIn = staySignedIn
    global.__askStaySignedIn = askStaySignedIn
    onRequestClose(true)
    onResponse(true)
  }

  return (<>
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Stay Signed In Modal"
      style={{
        overlay: {
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
        }
      }}
      className={styles.staySignedInModal}
    >
      <div className={styles.staySignedDiv}>
        <div className={styles.modalLogo}>
          {/* <button onClick={onRequestClose}>close</button> */}
          <Image src={EDXLogoLight} width={90} height={40} />
        </div>
        <div className={styles.modaltitle}>
          Stay Signed In
        </div>
        <div>
          Do this to reduce number of times  you are asked to sign in.
        </div>
        <div className={styles.staySignInWorkSpace}>
          <input onChange={(e) => setAskSignedIn(!e.target.checked)} type="checkbox" id="staysignedincheck" name="staysignedincheck" value="dontAsk" />
          <label htmlFor="staysignedincheck"> Don&apos;t show this again</label>
          <br></br>
          <div className={styles.staySignInButtonDiv}>
            <div>
              <button onClick={() => onSubmit(false)} >No</button>
              <button onClick={() => onSubmit(true)} >Yes</button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </>)
}

export function OtpVarification({ updateParentState, userName, password }) {

  const [loading, setLoading] = useState(false)
  const [timer, setTimer] = useState(30); // 30 seconds countdown
  const [resendOtp, setResendOtp] = useState(false);
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')
  var preverifyobj = {};
  const { createCancelableFetchOptions } = cancelRequests();

  let sendNewCodeClick = 0

  useEffect(() => {
    setError('')
    setSuccess('')
    setLoading(false)
  }, [])

  useEffect(() => {
    if (timer > 0) {
      const intervalId = setInterval(() => {
        setTimer(prevTimer => prevTimer - 1);
      }, 1000);

      return () => clearInterval(intervalId);
    } else {
      setResendOtp(true);
    }
  }, [timer]);

  async function handleSendNewOtp(event) {
    if (timer === 0) {
      // event.preventDefault()

      if (userName != "" && password != "") {
        // const formData = new FormData(event.target);
        try {
          var apiurl = ApiUrl.newUrl + "/api/presignin";
          const options = createCancelableFetchOptions({
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              username: userName,
              password: password,
              isportal: true,
              isSecurityCheck: false,
              isOTPSecurityCheck: true,
            }),
          })
          const res = await fetch(apiurl, options);

          const resp = await res.json();
          // console.log(resp);

          if (resp && resp.secToken) {

            if (resp.userLoginType == 0 || (resp.roles[0] != "External User" && resp.userLoginType == 1)) {
              if (true) {

              }
              if (resp.isNewUser) {
                preverifyobj = resp;
                preverifyobj.username = userName;
                preverifyobj.password = password;

                localStorage.setItem('preverifyobj', JSON.stringify(preverifyobj));
                setAction('Reset Credentials');
              }
              else {
                const signInResponse = await signIn("credentials",
                  {
                    username: userName,
                    password: password,
                    redirect: false
                  }
                )
                if (signInResponse.error) {
                  setLoading(false)
                  setError("Sign in failed. Check the details you provided are correct.");
                }
                else {
                  if (true) {
                    //   setIsSignedInModalOpen(true)
                  }

                  const updatedSession = await getSession(); // Wait for session to update
                  if (updatedSession) {
                    setLoading(false)
                    // console.log('Redirecting to home page...');
                  }
                }
              }
            }
            else {
              // localStorage.removeItem('preverifyobj');
              preverifyobj = resp;
              preverifyobj.username = userName;
              preverifyobj.password = password;

              localStorage.setItem('preverifyobj', JSON.stringify(preverifyobj));
              setAction('OTP Verification')
              setLoading(false)
            }
          }
          else {
            setError("Enter a valid UserID/Password.");
            setLoading(false)
          }


        } catch (error) {
          console.log(error)
          setError("An error occurred. Please try again later.");
          // setAction('OTP Verification')
          setLoading(false)
        }

        setError('')
        setSuccess('OTP sent to registered email')
        setTimer(30);
        setResendOtp(false);

      }

    }
  }

  async function handleSubmit(event) {
    event.preventDefault()
    //handle otp

    const elements = document.querySelectorAll('[id^="required-error-"]');
    elements.forEach(element => {
      element.textContent = ''
    });

    const formData = new FormData(event.target)
    if (formData.get('otp') === '') {
      const errorId = 'required-error-otp'
      const errorSpan = document.getElementById(errorId);
      errorSpan.textContent = 'please enter OTP';
    }
    else {
      //handle otp
      const storedPreverifyobj = JSON.parse(localStorage.getItem('preverifyobj'));
      const options = createCancelableFetchOptions({
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        },
        body: JSON.stringify({
          id: storedPreverifyobj.userid,
          secToken: storedPreverifyobj.secToken,
          vCode: formData.get('otp')
        }),
      }
      )
      try {
        const response = await fetch(ApiUrl.newUrl + "/api/getverificationcode", options);
        if (!response.ok) {
          setError("Verification code expired, please login again");
        }
        else {

          setLoading(false);
          const result = await response.json();
          if (result.success) {
            const storedPreverifyobj = JSON.parse(localStorage.getItem('preverifyobj'));
            if (storedPreverifyobj.isNewUser) {
              updateParentState('Reset Credentials');
            }
            else {
              const signInResponse = await signIn("credentials",
                {
                  username: storedPreverifyobj.username,
                  password: storedPreverifyobj.password,
                  redirect: false
                }
              )
              if (signInResponse.error) {
                setLoading(false)
                setError("Sign in failed. Check the details you provided are correct.");
              }
              else {
                if (true) {
                  //   setIsSignedInModalOpen(true)
                }

                const updatedSession = await getSession(); // Wait for session to update
                if (updatedSession) {
                  setLoading(false)
                  // console.log('Redirecting to home page...');
                }
              }
            }
          }
          else
            setError("Verification code expired, please login again");
        }
      } catch (e) {
        console.error("Error during OTP verification:", error);
        setError("Verification code expired, please login again");
        alert('Verification code expired, please login again')
      }



    }


    setLoading(true)
    setTimer(30);
    setResendOtp(false);
    setLoading(false)

  }
  return (
    <>
      <div className={styles.otpComponent}>

        <form id='login' method="post" onSubmit={handleSubmit}>
          <div className={styles.otpLableHandle}>
            <label htmlFor="otp" id="otp">Enter Verification code</label>
            {/* <span onClick={() => handleSendNewOtp()} className={timer === 0 ? styles.actionText : styles.disabledText}>Send new code? {timer != 0 && <span>({timer})</span>}</span> */}
            <span onClick={() => handleSendNewOtp()} className={timer === 0 ? styles.actionText : styles.disabledText}>Send new code? {timer != 0 && <span>({timer})</span>}</span>
          </div>

          <input id='otp' name="otp" type="text" placeholder='OTP' />
          <span className={styles.validationError} id='required-error-otp'></span>
          <br></br>
        </form>
        {/* <span id='capsLockCheck' className={styles.capsLockError}></span> */}

        {success && <span className={styles.success}>{success}</span>}
        {error && <span className={styles.error} id='error'>{error}</span>}
        <button form='login' disabled={loading}>{loading ? "Verifying..." : "Verify"}</button>
      </div>
    </>
  )

}

export function ResetCredModal() {


  const [images, setImages] = useState([]);
  //const [action, setAction] = useState('Sign In')
  const [topSuggestion, setTopSuggestion] = useState({ text: "Don't have an account?", action: "Register" })
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')
  const [validPass, setValidPass] = useState(false)
  const [currentPassVisible, currentPassEye, toggleCurrentPassVisibility] = usePasswordToggle()
  const [newPassVisible, newPassEye, toggleNewPassVisibility] = usePasswordToggle()
  const [confNewPassVisible, confNewPassEye, toggleConfNewPassVisibility] = usePasswordToggle()
  const [loading, setLoading] = useState(false)
  const { data: session } = useSession();
  const router = useRouter();
  const { createCancelableFetchOptions } = cancelRequests();
  useEffect(() => {
    setError('')
    setSuccess('')
    setLoading('')
    setValidPass(false)
  }, [])

  function validateCapsLock(event) {
    if (event.getModifierState) {
      const isCapsLockOn = event.getModifierState('CapsLock');
      const errorSpan = document.getElementById('capsLockCheck');
      if (isCapsLockOn) {
        errorSpan.textContent = 'CapsLock is on';
      }
      else {
        errorSpan.textContent = '';
      }
    }
  }

  function validatePassword(event) {
    document.getElementById('pass-error').textContent = ''
    let passValidationSet = [];
    const password = event.target.value;
    const errorSpan = document.getElementById('password-validation-error');
    errorSpan.textContent = '';

    const minLength = 8;
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    //const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);
    const hasSpecialChar = /[#$%@^<>&*()\-_=+.,?;:"[\]{}|!~]/.test(password);
    const hasSpace = /\s/.test(password);

    if (password.length < minLength) {
      //return `Password must be at least ${minLength} characters long.`;
      const errorSpan = document.getElementById('minLength').style.color = 'red'
    }
    else {
      const errorSpan = document.getElementById('minLength').style.color = 'green'
      passValidationSet.push(password.length >= minLength)
      //errorSpan.textContent = `Password must be at least ${minLength} characters long.`;
    }
    if (!hasUpperCase) {
      const errorSpan = document.getElementById('capitalLetter').style.color = 'red'
      ///return 'Password must contain at least one uppercase letter.';
    }
    else {
      const errorSpan = document.getElementById('capitalLetter').style.color = 'green'
      passValidationSet.push(hasUpperCase)
    }
    if (!hasLowerCase) {
      const errorSpan = document.getElementById('smallLetter').style.color = 'red'
      //return 'Password must contain at least one lowercase letter.';
    }
    else {
      const errorSpan = document.getElementById('smallLetter').style.color = 'green'
      passValidationSet.push(hasLowerCase)
    }
    if (!hasNumber) {
      const errorSpan = document.getElementById('numericChar').style.color = 'red'
      //return 'Password must contain at least one number.';
    }
    else {
      const errorSpan = document.getElementById('numericChar').style.color = 'green'
      passValidationSet.push(hasNumber)
    }
    if (!hasSpecialChar) {
      const errorSpan = document.getElementById('specialChar').style.color = 'red'
      //return 'Password must contain at least one special character (e.g. !@#$%^&*).';
    }
    else {
      const errorSpan = document.getElementById('specialChar').style.color = 'green'
      passValidationSet.push(hasSpecialChar)
    }
    if (hasSpace) {
      const errorSpan = document.getElementById('space').style.color = 'red'
    }
    else {
      const errorSpan = document.getElementById('space').style.color = 'green'
      passValidationSet.push(!hasSpace)
    }


    if (passValidationSet.length == 6) {
      const allTrue = passValidationSet.every(value => value === true);
      if (allTrue) {
        setValidPass(true)
        document.getElementById('passValidationWarning').style.display = 'none'
        document.getElementById('pass-success').textContent = 'valid'
        document.getElementById('pass-error').textContent = ''
        document.getElementById('temp').textContent = ''
        passValidationSet = []
      }
      else {
        document.getElementById('passValidationWarning').style.display = 'block'
        document.getElementById('pass-error').textContent = "Invalid format"
        document.getElementById('pass-success').textContent = ''
        setValidPass(false)
        passValidationSet = []
        //return false
      }
    }
    else {
      document.getElementById('passValidationWarning').style.display = 'block'
      document.getElementById('pass-error').textContent = "Invalid format"
      document.getElementById('pass-success').textContent = ''
      document.getElementById('required-error-newpass').textContent = ''
      setValidPass(false)
    }
  }

  function onPassFieldFocusEvent() {
    const warningDiv = document.getElementById('passValidationWarning');
    warningDiv.style.display = 'block'
    document.getElementById('temp').textContent = 'validating..'
  }
  function onPassFieldBlurEvent() {
    const warningDiv = document.getElementById('passValidationWarning');
    warningDiv.style.display = 'none'
    document.getElementById('temp').textContent = ''
  }


  async function handleSubmit(event) {

    event.preventDefault()
    // console.log("under submit")
    //handleSubmit
    const elements = document.querySelectorAll('[id^="required-error-"]');
    elements.forEach(element => {
      element.textContent = ''
    });
    document.getElementById('pass-error').textContent = ''
    let isFormValid = true
    const credentialData = new FormData(event.target)
    for (let key of credentialData.keys()) {
      if (credentialData.get(key).trim() === '') {
        const errorId = 'required-error-' + key
        const errorSpan = document.getElementById(errorId);
        errorSpan.textContent = 'required field';
        isFormValid = false
        return false
      }
    }
    if (!validPass) {
      document.getElementById('pass-error').textContent = "Invalid format"
      return false
    }
    if (credentialData.get('newpass') != credentialData.get('confirmnewpass')) {
      document.getElementById('pass-matching-error').textContent = 'passwords not matching'
      return false
    }
    if (isFormValid) {
      document.getElementById('pass-matching-error').textContent = ''
      document.getElementById('pass-error').textContent = ''
      setError('')
      //handle reset......
      const storedPreverifyobj = JSON.parse(localStorage.getItem('preverifyobj'));
      var currentpass = credentialData.get("currentpass")
      var newpass = credentialData.get("newpass")
      var apiurl = ApiUrl.newUrl + "/api/resetPassword";
      const options = createCancelableFetchOptions({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'

        },
        body: JSON.stringify({
          userid: storedPreverifyobj.userid,
          old: currentpass,
          new: newpass
        }),
      })
      const res = await fetch(apiurl, options);

      const resp = await res.json();
      // console.log(resp);
      if (resp && resp.success) {

        const storedPreverifyobj = JSON.parse(localStorage.getItem('preverifyobj'));
        // console.log("storedPreverifyobj " + storedPreverifyobj.username + "pass " + newpass)
        const signInResponse = await signIn("credentials",
          {
            username: storedPreverifyobj.username,
            password: newpass,
            redirect: false
          }
        )
        if (signInResponse.error) {
          console.log(signInResponse.error)
          setLoading(false)
          setError("Sign in failed. Check the details you provided are correct.");
        }
        else {
          if (true) {
            //   setIsSignedInModalOpen(true)
          }

          const updatedSession = await getSession(); // Wait for session to update
          if (updatedSession) {
            setLoading(false)
            console.log('Redirecting to home page...');
          }
        }



      }
      else
        signOut();
    }
    else {
      return false
    }
  }

  return (<>

    <div className={styles.formContent}>
      <form id='reset' method="post" onSubmit={handleSubmit}>

        <label htmlFor="currentpass" id="currentpass">Current Password</label><span className='requiredStar'>*</span>
        <div className='inputBox'>
          <input onKeyDown={(e) => validateCapsLock(e)} name="currentpass" id="currentpass" type={currentPassVisible ? "text" : "password"} placeholder='Current Password' autoComplete='new-password' />
          <span className={styles.passEyeIcon} onClick={toggleCurrentPassVisibility}>{currentPassEye}</span>
        </div>
        <span className={styles.validationError} id='required-error-currentpass'></span>
        <div className={styles.PassValidationInputDiv}>
          <label htmlFor="newpass" id="newpass">New Password</label><span className='requiredStar'>*</span>
          <div className='inputBox'>
            <input onKeyDown={(e) => validateCapsLock(e)}
              onFocus={() => onPassFieldFocusEvent()}
              onBlur={() => onPassFieldBlurEvent()}
              //onKeyUp={()=>{if(validPass){onPassFieldBlurEvent()}}}
              onKeyUp={(e) => validatePassword(e)}
              name="newpass"
              id="newpass"
              type={newPassVisible ? 'text' : 'password'}
              placeholder='New Password'
              autoComplete='new-password' />
            <span className={styles.passEyeIcon} onClick={toggleNewPassVisibility}>{newPassEye}</span>
          </div>
          <div id='passValidationWarning' className={styles.passValidationWarning2}>
            <span id='capitalLetter'>at least one capital letter</span><br></br>
            <span id='smallLetter'>at least one small letter</span><br></br>
            <span id='specialChar'>one special charector</span><br></br>
            <span id='numericChar'>one numeric character</span><br></br>
            <span id='minLength'>minimum length 6</span><br></br>
            <span id='space'>should not have space included</span>
          </div>
        </div>
        <div>
          <span className={styles.validationError} id='required-error-newpass'></span>
          <span className={styles.validationError} id='password-validation-error'></span>
          <span className={styles.validationError} id='pass-error'></span>
          <span className={styles.validationSuccess} id='pass-success'></span>
          <span className={styles.validationSuccess} id='temp'></span>
        </div>

        <label htmlFor="confirmnewpass" id="confirmnewpass">Confirm New Password</label><span className='requiredStar'>*</span>
        <div className='inputBox'>
          <input onKeyDown={(e) => validateCapsLock(e)} name="confirmnewpass" id="confirmnewpass" type={confNewPassVisible ? 'text' : 'password'} placeholder='Confirm New Password' autoComplete='new-password' />
          <span className={styles.passEyeIcon} onClick={toggleConfNewPassVisibility}>{confNewPassEye}</span>
        </div>
        <span className={styles.validationError} id='required-error-confirmnewpass'></span>
        <span className={styles.validationError} id='pass-matching-error'></span>

        <br></br>

      </form>

      <span id='capsLockCheck' className={styles.capsLockError}></span>
      <button form='reset' disabled={loading} className={styles.loginButton}>Reset</button>
      {success && <span className={styles.success}>{success}</span>}
    </div>
    {/* </Modal> */}
  </>)
}